<template>
    <div
        v-loading="specialistsAreLoading"
        class="specialist-list"
    >
        <el-table
            :data="preparedData"
            style="width: 100%"
        >
            <el-table-column
                label="Имя"
                prop="attributes.name"
                sortable
            >
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.attributes.name }}
                        <i
                            class="el-icon-edit-outline specialist-list__icon specialist-list__edit"
                            title="Редактировать"
                            @click="_tryEdit(scope)"
                        />
                        <i
                            class="el-icon-refresh specialist-list__icon specialist-list__reset"
                            title="Сбросить пароль"
                            @click="_tryResetPassword(scope)"
                        />
                    </div>
                    <div style="font-size: .8em; color: #888;" />
                </template>
            </el-table-column>
            <el-table-column
                label="Логин"
                prop="attributes.username"
                sortable
            >
                <template slot-scope="scope">
                    <div> {{ scope.row.attributes.username ? scope.row.attributes.username : 'Не задан' }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="Вход в ЛК разрешен"
            >
                <template slot-scope="scope">
                    <el-switch
                        :value="scope.row.attributes.enabled"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="_changeStatus(scope.row.attributes)"
                    />
                </template>
            </el-table-column>
            <el-table-column
                :width="60"
                align="center"
            >
                <template slot-scope="scope">
                    <i
                        class="el-icon-delete specialist-list__icon specialist-list__remove"
                        title="Удалить"
                        @click="_tryRemove(scope)"
                    />
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import { Specialist } from '@/api';
import showError from '@/utils/showError';

export default {
    name: 'SpecialistList',

    props: {
        search: {
            type: String,
            default: ''
        }
    },

    computed: {
        ...mapState('specialist/list', [
            'specialists',
            'specialistsAreLoading'
        ]),

        preparedData() {
            const search = this.search.trim().toLowerCase();

            if (!search) {
                return this.specialists;
            }

            return this.specialists.filter(specialist => {
                const name = String(_.get(specialist, 'attributes.name') || '').toLowerCase();
                const username = String(_.get(specialist, 'attributes.username') || '').toLowerCase();

                return name.includes(search) || username.includes(search);
            });
        }
    },

    mounted() {
        this._loadData();
    },

    methods: {
        ...mapActions('specialist/list', [
            'getSpecialists',
            'setSpecialistToEdit'
        ]),

        reload() {
            this._loadData();
        },

        _tryEdit({ row, $index }) {
            this.setSpecialistToEdit({ specialistId: row.id });
            this.$emit('edit', { specialist: row });
        },

        _tryResetPassword({ row }) {
            this.$confirm(
                `Сбросить пароль для специалиста "${row.attributes.name}"?`,
                'Подтверждение',
                {
                    type: 'warning'
                }
            )
                .then(() => Specialist.resetPassword({ specialistId: row.id })
                    .catch(showError('Не удалось сбросить пароль')))
                .then(result => {
                    if (!result) {
                        return;
                    }

                    this.$message.success('Новый пароль сгенерирован');
                    this.$emit('password-reset', {
                        specialist: row,
                        passwordResetResult: result
                    });
                })
                .catch(() => {
                });
        },

        _tryRemove({ row, $index }) {
            this.$confirm('Вы уверены, что хотите удалить специалиста?')
                .then(() => this._remove({ row, index: $index }))
                .catch(() => {
                });
        },

        _changeStatus(attributes) {
            Specialist.update(Object.assign(attributes, { enabled: !attributes.enabled }))
                .then(() => {
                    this.$message.success('Статус обновлен');
                    this.reload();
                })
                .catch(showError('Не удалось изменить статус'));
        },

        _remove({ row }) {
            const onResponse = () => {
                this.$message.success(`Специалист удален`);
                this.reload();
            };
            Specialist.remove({ specialistId: row.id })
                .then(onResponse)
                .catch(showError('Не удалось удалить специалиста'));
        },

        _loadData() {
            this.getSpecialists();
        }
    }
};
</script>

<style lang="scss">
@import "@vars";

.specialist-list {
    &__icon {
        font-size: 1.2em;
        cursor: pointer;
        visibility: hidden;
    }

    &__edit {
        color: #0486fe;
        margin-left: 10px;
    }

    &__reset {
        color: #e6a23c;
        margin-left: 10px;
    }

    &__remove {
        color: #eb2929;
    }

    .el-table__row {
        &:hover {
            .specialist-list__icon {
                visibility: visible;
            }
        }
    }
}
</style>
